<template>
  <div class="error-container">
    <div v-if="isDev">
      <h1>{{ error.statusCode }}</h1>
      <p>{{ error.statusMessage || 'An unexpected error occurred.' }}</p>
      <p>
        {{ error.stack }}
      </p>
    </div>
    <PageNotFound />
  </div>
</template>

<script setup>
import PageNotFound from './components/NotFound';

const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
  forceDev: {
    type: Boolean,
    default: false,
  },
});

const isDev = import.meta.dev || props.forceDev; // forceDev is for testitng
</script>

<style scoped>
.error-container {
  text-align: center;
  padding: 4rem;
}
</style>
